var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":""}},[_c('rect',{attrs:{"width":"5","height":"20","fill":"currentColor"}}),_c('rect',{attrs:{"x":"15","width":"5","height":"20","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }